import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { FinancialsCard } from "./FinancialsCard";
import { Col, Row, Spinner } from "react-bootstrap";
import "./Financials.scss";
import { useDispatch, useSelector } from "react-redux";
import { facilityList } from "../../../redux/actions/dbactions/facilityActions";

import { Header } from "../../Header";
import FinancialsIcon from "../../../../assets/FinancialsIcon";

const Financials = ({ searchQuery }) => {
  const dispatch = useDispatch();
  const { facility, isLoading } = useSelector((state) => state.facilitylist);

  const [refresh] = useState(true);

  // Facility API call on refresh this has calendar view
  useEffect(() => {
    if (refresh) {
      dispatch(facilityList("calendar"));
    }
  }, [dispatch, refresh]);

  const filteredValues = facility?.usr?.rec[0]?.daily_orders;
  return (
    <div>
      <Header pageTitle="Financials Details" icon={<FinancialsIcon />} />
      <div className="ser_title_b sm:!px-8 !px-4 mt-4">
        <h5>Financials (past 2 week est.)</h5>
      </div>
      {isLoading ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : null}
      <Row className="sm:px-4 m-0">
        {filteredValues?.length > 0 ? (
          filteredValues?.map((item, index) => (
            <Col className="mb-3" lg={4} md={6} key={index}>
              <FinancialsCard data={item} />
            </Col>
          ))
        ) : (
          <Col>
            <p className="text-center">No financials to display</p>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default withRouter(Financials);
